import * as React from 'react'
import type { SVGProps } from 'react'

interface SvgInvoiceProps extends SVGProps<SVGSVGElement> {
  isActive?: boolean
}

const ACTIVE_COLOR = '#002A73'
const INACTIVE_STROKE_COLOR = '#CECECE'

const ICON_SIZE = 28
const VIEW_BOX = '0 0 28 28'

const highlightPathD =
  'M18.375 21.875V11.375H24.5V21C24.5 21.2321 24.4078 21.4546 24.2437 21.6187C24.0796 21.7828 23.8571 21.875 23.625 21.875H18.375Z'
const dollarSignPathD =
  'M7 6.125H4.375C3.91087 6.125 3.46575 6.30937 3.13756 6.63756C2.80937 6.96575 2.625 7.41087 2.625 7.875C2.625 8.33913 2.80937 8.78425 3.13756 9.11244C3.46575 9.44063 3.91087 9.625 4.375 9.625H6.125C6.58913 9.625 7.03425 9.80937 7.36244 10.1376C7.69063 10.4658 7.875 10.9109 7.875 11.375C7.875 11.8391 7.69063 12.2842 7.36244 12.6124C7.03425 12.9406 6.58913 13.125 6.125 13.125H3.0625'
const dollarTopTickPathD = 'M5.25 5.25V6.125'
const dollarBottomTickPathD = 'M5.25 13.125V14'
const mainOutlinePathD =
  'M10.5 6.125H24.5V21C24.5 21.2321 24.4078 21.4546 24.2437 21.6187C24.0796 21.7828 23.8571 21.875 23.625 21.875H4.375C4.14294 21.875 3.92038 21.7828 3.75628 21.6187C3.59219 21.4546 3.5 21.2321 3.5 21V16.625'
const middleLinePathD = 'M11.375 11.375H24.5'
const bottomLinePathD = 'M8.75 16.625H24.5'
const verticalLinePathD = 'M18.375 11.375V21.875'

const SvgInvoice = ({
  isActive = false,
  stroke,
  width,
  height,
  ...props
}: SvgInvoiceProps) => {
  const currentStrokeColor = isActive
    ? ACTIVE_COLOR
    : stroke || INACTIVE_STROKE_COLOR

  return (
    <svg
      {...props}
      width={width ?? ICON_SIZE}
      height={height ?? ICON_SIZE}
      viewBox={VIEW_BOX}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      {isActive && (
        <path opacity='0.2' d={highlightPathD} fill={ACTIVE_COLOR} />
      )}

      <path
        d={dollarSignPathD}
        stroke={currentStrokeColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />

      <path
        d={dollarTopTickPathD}
        stroke={currentStrokeColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />

      <path
        d={dollarBottomTickPathD}
        stroke={currentStrokeColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />

      <path
        d={mainOutlinePathD}
        stroke={currentStrokeColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />

      <path
        d={middleLinePathD}
        stroke={currentStrokeColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />

      <path
        d={bottomLinePathD}
        stroke={currentStrokeColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />

      <path
        d={verticalLinePathD}
        stroke={currentStrokeColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default SvgInvoice
